import { render, staticRenderFns } from "./ConcordiaChem206Experiment1Part1Explanation.vue?vue&type=template&id=2567b1e7&scoped=true&"
import script from "./ConcordiaChem206Experiment1Part1Explanation.vue?vue&type=script&lang=ts&"
export * from "./ConcordiaChem206Experiment1Part1Explanation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2567b1e7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
